import HighlightCategoryColors from 'styles/HighlightCategoryColors';

export const DEFAULT_NEW_CATEGORY = {
  uuid: 'new',
  name: '',
  description: '',
  keywords: [],
  backgroundColor:
    HighlightCategoryColors[Object.keys(HighlightCategoryColors)[0]].background,
  settings: {}
};

export const DEFAULT_EXAMPLE_SENTENCES = [
  { sentence: '' },
  { sentence: '' },
  { sentence: '' },
  { sentence: '' },
  { sentence: '' },
  { sentence: '' }
];

export const ERROR_MESSAGES = {
  dupeName: 'Tracker with this label already exists',
  dupeSentence: 'Duplicate sentences found'
};

export const LENGTH_OPTIONS = {
  text: [
    { label: 'Short', value: 'short' },
    { label: 'Medium', value: 'medium' },
    { label: 'Long', value: 'long' }
  ],
  number: [
    { label: 'One Decimal', value: 'one_decimal' },
    { label: 'Two Decimals', value: 'two_decimals' }
  ],
  currency: [
    { value: 'USD', label: '$' },
    { value: 'EUR', label: '€' },
    { value: 'GBP', label: '£' },
    { value: 'JPY', label: '¥' },
    { value: 'CAD', label: 'CA$' },
    { value: 'INR', label: '₹' }
  ],
  date_and_time: [
    { label: 'MM/DD/YY', value: 'mm/dd/yy' },
    { label: 'DD/MM/YY', value: 'dd/mm/yy' },
    { label: 'YYYY/MM/DD', value: 'yyyy/mm/dd' },
    { label: 'YYYY/DD/MM', value: 'yyyy/dd/mm' }
  ]
};

export const FORMAT_OPTIONS = {
  text: [
    {
      label: 'Bullet points',
      value: 'bullet',
      lengthOptions: [...LENGTH_OPTIONS.text]
    },
    // TODO: Disabled for now. Enable this when the backend is ready.
    // {
    //   label: 'Checklist',
    //   value: 'checklist',
    //   lengthOptions: [...LENGTH_OPTIONS.text]
    // },
    {
      label: 'Paragraph',
      value: 'paragraph',
      lengthOptions: [...LENGTH_OPTIONS.text]
    }
  ],
  number: [
    {
      label: 'Default',
      value: 'number_default',
      lengthOptions: [...LENGTH_OPTIONS.number]
    },
    {
      label: 'Percentage',
      value: 'percentage',
      lengthOptions: [...LENGTH_OPTIONS.number]
    },
    {
      label: 'Currency',
      value: 'currency'
      // TODO: Disabled for now. Enable this when the backend is ready.
      // lengthOptions: [...LENGTH_OPTIONS.currency]
    }
  ],
  date_and_time: [
    {
      label: 'Date',
      value: 'date',
      lengthOptions: [...LENGTH_OPTIONS.date_and_time]
    },
    {
      label: 'Date and Time',
      value: 'datetime'
    }
  ]
};

export const DEFAULT_TEXT_FORMAT_OPTIONS = {
  selectedFormatOption: 'bullet',
  selectedLengthOption: 'medium'
};

export const DEFAULT_NUMBER_FORMAT_OPTIONS = {
  selectedFormatOption: 'number_default',
  selectedLengthOption: 'one_decimal'
};

export const DEFAULT_DATE_AND_TIME_FORMAT_OPTIONS = {
  selectedFormatOption: 'date',
  selectedLengthOption: 'mm/dd/yy'
};
